import React from 'react';
import { Tag } from 'antd';
import { resolveVideoAtSeconds } from '../../utils/incidentLog';
import { formatPauseClock } from '../../utils/youtube';

export default function IncidentLogAside({ incidentLog, activeLogEntry, onJumpToLog }) {
  if (!incidentLog?.length) return null;

  return (
    <aside className="testing-exercising-media__log" aria-label="Incident log">
      <h3>Incident log</h3>
      <p className="testing-exercising-media__log-intro">
        Predetermined bookmarks for each section of this video. Click a row to jump there.
      </p>
      <ol>
        {incidentLog.map((entry) => {
          const seekAt = resolveVideoAtSeconds(entry);
          const isActive = Boolean(activeLogEntry && entry.id === activeLogEntry.id);
          const canSeek = seekAt != null;
          return (
            <li
              key={entry.id}
              className={[isActive ? 'is-current' : '', canSeek ? 'is-seekable' : ''].filter(Boolean).join(' ')}
            >
              <button
                type="button"
                className="testing-exercising-media__log-jump"
                disabled={!canSeek}
                onClick={() => onJumpToLog(entry)}
                aria-current={isActive ? 'true' : undefined}
                title={canSeek ? `Jump to ${formatPauseClock(seekAt)} on the video` : undefined}
              >
                <div className="testing-exercising-media__log-row">
                  <span className="testing-exercising-media__log-time">
                    {canSeek ? formatPauseClock(seekAt) : entry.time}
                  </span>
                  {entry.tag ? <Tag className="testing-exercising-media__log-tag">{entry.tag}</Tag> : null}
                </div>
                <p className="testing-exercising-media__log-body">{entry.message}</p>
                {canSeek ? (
                  <span className="testing-exercising-media__log-seek-hint">Jump · {formatPauseClock(seekAt)}</span>
                ) : null}
              </button>
            </li>
          );
        })}
      </ol>
    </aside>
  );
}
